import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { getDataAttributes } from '../../../../../../util/getDataAttributes/getDataAttributes.js';
import { Box } from '../../../../../Box/Box.js';
import { Track as TrackMemoized } from '../../../../Track/Track.js';

var StepContainer = Box;
var MarkerAndTrackContainer = Box;
var SlotContainer = Box;
var VerticalStep = function VerticalStep(props) {
  var endSlot = props.endSlot,
    startSlot = props.startSlot,
    isLastStep = props.isLastStep,
    stepContainerProps = props.stepContainerProps,
    trackContainerProps = props.trackContainerProps,
    trackProps = props.trackProps,
    marker = props.marker;
  var _getDataAttributes = getDataAttributes(props),
    dataAttributes = _getDataAttributes.dataAttributes;
  return /*#__PURE__*/React.createElement(StepContainer, _extends({}, stepContainerProps, dataAttributes), /*#__PURE__*/React.createElement(SlotContainer, {
    pb: !isLastStep ? '12' : undefined
  }, startSlot), /*#__PURE__*/React.createElement(MarkerAndTrackContainer, _extends({}, trackContainerProps, {
    "aria-hidden": "true"
  }), marker, !isLastStep && /*#__PURE__*/React.createElement(TrackMemoized, trackProps)), /*#__PURE__*/React.createElement(SlotContainer, {
    pb: !isLastStep ? '12' : undefined
  }, endSlot));
};
var VerticalStepMemoized = /*#__PURE__*/React.memo(VerticalStep);

export { VerticalStep as BaseVerticalStep, VerticalStepMemoized as VerticalStep };
//# sourceMappingURL=VerticalStep.js.map
